/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="./egifts.base.section.ts" />

module Meevo.Plugins.Egifts {
    'use strict';

    import NotificationTags = Meevo.Components.Common.NotificationTags;
    import EgfitCommunicationTypeEnum = Meevo.Plugins.Egifts.EgfitCommunicationTypeEnum;
    import INotification = Meevo.Plugins.Egifts.EgiftNotificationsSection.INotification;
    import NotificationTemplate = Meevo.Plugins.Egifts.EgiftNotificationsSection.NotificationTemplate;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IModalOptions = Meevo.Components.Modal.IModalOptions;
    import NotificationItemTypeEnum = Meevo.Plugins.Egifts.EgiftNotificationsSection.NotificationItemTypeEnum;

    export class NotificationsSection extends EgiftsBaseSection {
        public charLimit: number;

        public deliveryMethods: Array<EgiftNotificationsSection.IDeliveryMethods> = this.deliveryMethodsData;

        notificationSections: NotificationTemplate = {
            [EgfitCommunicationTypeEnum.EgiftRecipientEmail]: {
                title: 'LABEL_EGIFT_RECEPIENT_EMAIL',
                order: 1,
                template: null,
                showFilter: true,
                type: EgfitCommunicationTypeEnum.EgiftRecipientEmail,
                tags: this.notificationRecepientEmailData,

                filter: {
                    model: this._selectedItemType,
                    label: 'Item type',
                    options: this.itemTypes,
                    applyHandler: this.getTemplate.bind(this)
                },
            },

            [EgfitCommunicationTypeEnum.EgiftShippedEmail]: {
                title: 'LABEL_EGIFT_SHIPPING_INFO_PURCHASER',
                hidden: !this.isMailDeliveryEnabled,
                order: 2,
                template: null,
                type: EgfitCommunicationTypeEnum.EgiftShippedEmail,
                tags: this.notificationShippedEmailData,
            },
            [EgfitCommunicationTypeEnum.EgiftPurchaserEmail]: {
                title: 'LABEL_EGIFT_PURCHASER_EMAIL',
                order: 3,
                template: null,
                showFilter: true,
                type: EgfitCommunicationTypeEnum.EgiftPurchaserEmail,
                tags: this.notificationPurchaserEmailData[this.defaultDeliveryMethod],
                filter: {
                    model: this._purchaserSelectedDeliveryMethod,
                    label: 'LABEL_DELIVERY_METHOD',
                    options: this.deliveryMethodsData,
                    applyHandler: this.getTemplate.bind(this)
                },
            },

        };

        constructor(params: ISectionParamsEgifts,
            protected defaultDeliveryMethod: DeliveryMethodEnum,
            protected defaultItemType: NotificationItemTypeEnum,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $scope: angular.IScope,
            protected translate: angular.translate.ITranslateService) {

            super(params);

            this.charLimit = 128;
        }

        addTag(tag: string): void {
            this.$scope.$broadcast('insertTag', { tagName: tag });
        }

        activate() {
            this.notificationSections[EgfitCommunicationTypeEnum.EgiftShippedEmail].hidden = !(<MainSection>this.context.sections[0]).model.settings.mailEnable;
            
            this.model.forEach((item: INotification, i, arr) => {
                if (this.notificationSections[item.communicationType]) {
                    this.notificationSections[item.communicationType].template = item;
                    this.notificationSections[item.communicationType].templateBackup = angular.copy(item);
                }
            });

        }

        preview(event, emailBody): void {
            // preview does not stay in mobile view. this stops it from automatically closing 
            event.preventDefault();
            event.stopPropagation();

            let options: Meevo.Components.Modal.IModalOptions = {
                template: emailBody,
                clickOutsideToClose: true
            };

            this.modalService.showCustom(options);
        }

        reloadData(): void {
            Object.keys(this.notificationSections).forEach((key: string) => {
                this.notificationSections[key].template = angular.copy(this.notificationSections[key].templateBackup);
            });
        }

        preSave(): void {
            //fixing request issue
            this.model = Object.keys(this.notificationSections).map((key: string) => {
                if (this.notificationSections[key].template) {
                    this.notificationSections[key].template.objectState = ObjectStateEnum.Active
                    !this.notificationSections[key].template.displayName ? this.notificationSections[key].template.displayName = this.getGuid() : null
                    this.notificationSections[key].template.isDefault = this.notificationSections[key].template.id ? false : true;
                    return this.notificationSections[key].template;
                }
            });
        }

        // Work only on Select Section
        getData() {
            this.notificationSections[EgfitCommunicationTypeEnum.EgiftPurchaserEmail].filter.model = this._purchaserSelectedDeliveryMethod;
            this.notificationSections[EgfitCommunicationTypeEnum.EgiftRecipientEmail].filter.model = this._selectedItemType;
        }

        customSave(): ng.IPromise<any> {
            return this.egiftsService.saveNotifications({ templates: this.model });
        }

        getGuid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

        getTemplate(selectedNotification: any) {
            this.busyService.start();
            this.egiftsService.getEmailTemplateByDeliveryMethod(
                this.notificationSections[EgfitCommunicationTypeEnum.EgiftPurchaserEmail].filter.model.value,
                this.notificationSections[EgfitCommunicationTypeEnum.EgiftRecipientEmail].filter.model.value)
                    .then((data: Array<EgiftNotificationsSection.INotification>) => {

                        const emailTemplate = data.find(template => template.communicationType === selectedNotification.filter.model.communicationType);

                        this.notificationSections[selectedNotification.type].template = emailTemplate;
                        this.notificationSections[selectedNotification.type].templateBackup = angular.copy(emailTemplate);
                    }).finally(() => {
                        this.busyService.stop();
                    })
        }

        getNotificationTemplate(sectionType: EgfitCommunicationTypeEnum, communicationType: EgfitCommunicationTypeEnum) {
            this.egiftsService.getNotificationTemplate(communicationType)
                .then(template => {
                    this.notificationSections[sectionType].template.emailBody = template.emailBody;
                    this.notificationSections[sectionType].template.emailSubject = template.emailSubject;
                });
        }

        public confirmResetHandler(notification: any, type: EgfitCommunicationTypeEnum): void {
            let options: IModalOptions = this.getOptions(notification.title)

            this.modalService.showCustom(options).then((result: boolean) => {
                if (result) this.getNotificationTemplate(notification.type, type)
            });
        }

        get egfitCommunicationTypeEnum() {
            return EgfitCommunicationTypeEnum;
        }

        get deliveryMethodEnum() {
            return DeliveryMethodEnum;
        }

        ////Notifications DATA////

        get deliveryMethodsData(): Array<EgiftNotificationsSection.IDeliveryMethods> {
            return [
                { value: DeliveryMethodEnum.EMail, communicationType: EgfitCommunicationTypeEnum.EgiftPurchaserEmail, label: 'HEADER_EMAIL' },
                { value: DeliveryMethodEnum.Mail, communicationType: EgfitCommunicationTypeEnum.EgiftPurchaserEmailForMail, label: 'LABEL_MAIL' },
                { value: DeliveryMethodEnum.StorePickup, communicationType: EgfitCommunicationTypeEnum.EgiftPurchaserEmailForPickUp, label: 'LABEL_EGIFT_ALONE_STORE_PICKUP' }
            ];
        }


        get itemTypes() {
            return [
                { value: NotificationItemTypeEnum.GiftCard, communicationType: EgfitCommunicationTypeEnum.EgiftRecipientEmail, label: 'LABEL_GIFT_CARD' },
                { value: NotificationItemTypeEnum.Package, communicationType: EgfitCommunicationTypeEnum.EgiftRecipientEmailPackage, label: 'CUSTOM_LABEL_PACKAGE' }
            ]
        }

        getTags(tagsToInsert: NotificationTags[]): NotificationTags[] {
            return [
                NotificationTags.BUSINESS_NAME,
                NotificationTags.EGIFT_FROM,
                NotificationTags.EGIFT_TO,
                NotificationTags.BUSINESS_ADDRESS_ADDRESS_1,
                NotificationTags.BUSINESS_ADDRESS_ADDRESS_2,
                NotificationTags.BUSINESS_ADDRESS_CITY,
                NotificationTags.BUSINESS_ADDRESS_STATE,
                NotificationTags.BUSINESS_ADDRESS_ZIP_CODE,
                NotificationTags.BUSINESS_EMAIL_ADDRESS,
                NotificationTags.BUSINESS_PHONE_NUMBER,
                NotificationTags.BOOK_NOW,
                NotificationTags.EGIFT_FROMS_EMAIL,
                NotificationTags.EGIFT_VALUE,
                NotificationTags.ITEM_TYPE,
                NotificationTags.ITEM_DISPLAY_NAME,
                NotificationTags.SERVICE_PACKAGE_INFORMATION,

                ...tagsToInsert,

                NotificationTags.CUSTOM_BRANDING_LOGO,
                NotificationTags.SOCIAL_MEDIA_FACEBOOK,
                NotificationTags.SOCIAL_MEDIA_INSTAGRAM,
                NotificationTags.SOCIAL_MEDIA_PINTEREST,
                NotificationTags.SOCIAL_MEDIA_TWITTER,
                NotificationTags.SOCIAL_MEDIA_YOUTUBE
            ]
        }

        get notificationPurchaserEmailData() {
            return {
                [DeliveryMethodEnum.EMail]:
                    this.getTags([
                        NotificationTags.EGIFT_LINK,
                        NotificationTags.EGIFT_NUMBER,
                        NotificationTags.EGIFT_PROMOTION_CODE,
                        NotificationTags.EGIFT_DELIVERY_METHOD,
                        NotificationTags.EGIFT_PROCESSING_FEE,
                    ]),
                [DeliveryMethodEnum.Mail]:
                    this.getTags([
                        NotificationTags.EGIFT_SHIP_TO_ADDRESS,
                        NotificationTags.EGIFT_SHIPPING_FEE,
                        NotificationTags.EGIFT_TRANSACTION_NUMBER,
                        NotificationTags.EGIFT_PROMOTION_CODE,
                        NotificationTags.EGIFT_DELIVERY_METHOD,
                        NotificationTags.EGIFT_PROCESSING_FEE,
                    ]),
                [DeliveryMethodEnum.StorePickup]:
                    this.getTags([
                        NotificationTags.EGIFT_TRANSACTION_NUMBER,
                        NotificationTags.EGIFT_PROMOTION_CODE,
                        NotificationTags.EGIFT_DELIVERY_METHOD,
                        NotificationTags.EGIFT_PROCESSING_FEE,
                    ])
            };
        }


        get notificationRecepientEmailData(): NotificationTags[] {
            return this.getTags([NotificationTags.EGIFT_LINK]);
        }

        get notificationShippedEmailData(): NotificationTags[] {
            return this.getTags([
                NotificationTags.EGIFT_SHIP_TO_ADDRESS,
                NotificationTags.EGIFT_SHIPPING_FEE,
                NotificationTags.EGIFT_TRANSACTION_NUMBER,
                NotificationTags.EGIFT_PROMOTION_CODE,
                NotificationTags.EGIFT_DELIVERY_METHOD,
                NotificationTags.EGIFT_PROCESSING_FEE,
                NotificationTags.SHIPPING_RATE_DISPLAY_NAME,
                NotificationTags.TRACKING_NUMBER,
            ])
        }


        private get _purchaserSelectedDeliveryMethod() {
            return this.deliveryMethods.find(method => method.value === this.defaultDeliveryMethod);
        }

        private get _selectedItemType() {
            return this.itemTypes.find(itemType => itemType.value === this.defaultItemType);
        }

        private get isMailDeliveryEnabled() {
            return (<any>this.context).egiftSettings.settings.mailEnable;
        }

        getOptions(email: string): IModalOptions {
            return {
                templateUrl: 'app/components/modal/modal.template.html',
                clickOutsideToClose: false,
                controller: 'meevo.components.modal.ModalController',
                bindToController: true,
                controllerAs: 'vm',
                preserveScope: true,
                hasBackdrop: false,

                locals: {
                    modalType: null,
                    headerContentKey: 'HEADER_WARNING',
                    modalClass: 'modal-warning',
                    message: this.translate.instant('LABEL_RESET_NOTIFICATION', { email: this.translate.instant(email) }),
                    showCancelButton: true,
                    showOkButton: true,
                    cancelButtonContentKey: 'LABEL_NO',
                    okButtonContentKey: 'LABEL_YES',
                }
            }
        }

    }
}
